/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
	type EasyClaimCaseResponseDto,
	EasyClaimCaseResponseDtoFromJSON,
	EasyClaimCaseResponseDtoToJSON,
} from '../models/EasyClaimCaseResponseDto';
import { type Language, LanguageFromJSON, LanguageToJSON } from '../models/Language';

export interface ApiV1SGetRequest {
	i: string;
	l?: Language;
}

/**
 *
 */
export class LinkApi extends runtime.BaseAPI {
	/**
	 * Creates request options for apiV1SGet without sending the request
	 */
	async apiV1SGetRequestOpts(requestParameters: ApiV1SGetRequest): Promise<runtime.RequestOpts> {
		if (requestParameters['i'] == null) {
			throw new runtime.RequiredError(
				'i',
				'Required parameter "i" was null or undefined when calling apiV1SGet().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['i'] != null) {
			queryParameters['i'] = requestParameters['i'];
		}

		if (requestParameters['l'] != null) {
			queryParameters['l'] = requestParameters['l'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/s`;

		return {
			path: urlPath,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV1SGetRaw(
		requestParameters: ApiV1SGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<EasyClaimCaseResponseDto>> {
		const requestOptions = await this.apiV1SGetRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			EasyClaimCaseResponseDtoFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiV1SGet(
		requestParameters: ApiV1SGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<EasyClaimCaseResponseDto> {
		const response = await this.apiV1SGetRaw(requestParameters, initOverrides);
		return await response.value();
	}
}
